import { BaseUnit } from './BaseUnit';
import { Enemy } from '../Enemy';
import { Projectile } from '../Projectile';
import { SPEAR_THROWER } from '../../config';
import { StickFigureGraphics } from '../../rendering/StickFigureGraphics';

export class SpearThrower extends BaseUnit {
  private attackTimer: number = 0;
  private throwPhase: number = 0;
  private projectiles: Projectile[];

  constructor(scene: Phaser.Scene, x: number, y: number, slotIndex: number, projectiles: Projectile[]) {
    super(scene, x, y, slotIndex);
    this.projectiles = projectiles;
    this.targetPriority = 'lowestHP';
    this.draw();
  }

  getDamage(): number {
    const perUnitDamage = Math.round(SPEAR_THROWER.baseDamage * this.bonusDamageMult * this.globalDamageMult);
    return perUnitDamage * this.stackCount;
  }

  getPierceCount(): number {
    return SPEAR_THROWER.basePierceCount + this.bonusPierceCount;
  }

  update(time: number, delta: number, enemies: Enemy[]): void {
    if (this.throwPhase > 0) {
      this.throwPhase -= delta * 0.003;
      if (this.throwPhase < 0) this.throwPhase = 0;
    }

    this.attackTimer -= delta;
    if (this.attackTimer <= 0) {
      const target = this.findTarget(enemies, SPEAR_THROWER.range);
      if (target) {
        this.attackTimer = this.getEffectiveAttackInterval(SPEAR_THROWER.baseAttackInterval);
        this.throwPhase = 1;
        this.fire(target);
      } else {
        this.attackTimer = 0;
      }
    }

    this.draw();
  }

  private fire(target: Enemy): void {
    const proj = new Projectile(this.scene, this.x + 10, this.y - 10, {
      damage: this.getDamage(),
      speed: SPEAR_THROWER.projectileSpeed,
      piercing: true,
      projectileType: 'spear',
      targetX: target.x,
      targetY: target.y,
      maxPierceCount: this.getPierceCount(),
      knockbackDistance: this.knockbackDistance,
    });
    this.projectiles.push(proj);
  }

  draw(): void {
    if (this.throwPhase <= 0) {
      this.sprite.setTexture('friendly_spear_idle');
    } else {
      let frame = Math.floor((1 - this.throwPhase) * 8);
      if (frame < 0) frame = 0;
      if (frame > 7) frame = 7;
      this.sprite.setTexture(`friendly_spear_${frame}`);
    }

    this.graphics.clear();
    if (this.level > 1) {
      this.graphics.fillStyle(0xffd700, 1);
      for (let i = 0; i < Math.min(this.level - 1, 5); i++) {
        this.graphics.fillCircle(this.x - 8 + i * 4, this.y + 16, 1.5);
      }
    }
  }
}
